import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../../../../loader/Loader";
import AxiosController from "../../../../authentication/AxiosController";
import { Button, Table } from "react-bootstrap";
import StatisticsSearchComponent from "../search components/StatisticsSearchComponent";

const ProductsOverview = () => {
  const { slug, lang } = useParams();
  const { t } = useTranslation("global");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [search, setSearch] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [productId, setProductId] = useState("");
  const [categoryIds, setCategoryIds] = useState("");
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const [sortConfig, setSortConfig] = useState({
    key: "total_orders_count",
    direction: "desc",
  });
  const getProductsOverview = () => {
    setLoading(true);
    AxiosController.get(`api/${slug}/${lang}/reports/products-overview`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        start_date: startDate,
        end_date: endDate,
        product_id: productId,
        category_ids: categoryIds,
      },
    })
      .then((res) => {
        setLoading(false);
        setAllData(res?.data?.products || []);
      })
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    setProductId(urlParams.get("product_id") || "");
    setCategoryIds(urlParams.get("category_ids") || "");
    setStartDate(urlParams.get("start_date") || "");
    setEndDate(urlParams.get("end_date") || "");
  }, [urlParams]);

  useEffect(() => {
    getProductsOverview();
  }, [startDate, endDate, productId, categoryIds]);
  const handleSort = (key) => {
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key, direction });

    const sortedData = [...allData].sort((a, b) => {
      const aValue = a[key] ?? "";
      const bValue = b[key] ?? "";

      if (typeof aValue === "string" && typeof bValue === "string") {
        return direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (typeof aValue === "number" && typeof bValue === "number") {
        return direction === "asc" ? aValue - bValue : bValue - aValue;
      }

      return 0;
    });

    setAllData(sortedData);
  };
  const getSortIndicator = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? " 🔼" : " 🔽";
    }
    return " ↕️";
  };
  return (
    <div className="flex-grow-1 stats-component mt-3">
      <Button
        className="fs-5 w-25 mb-4 align-self-start"
        style={{
          backgroundColor: "rgb(89, 198, 201)",
          border: "none",
          borderRadius: "7px",
        }}
        onClick={() => setSearch(!search)}
      >
        {t("panel.search")}
      </Button>
      {search && <StatisticsSearchComponent type={"product"} />}

      <div className="reports-container my-3 d-flex flex-column gap-2 px-2 position-relative">
        <Loader active={loading} />
        <div className="reports-header d-flex flex-column flex-md-row py-2 justify-content-between flex-wrap">
          <h3 className="fs-2 mb-4" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {t("panel.productsOverview")}
          </h3>
        </div>

        <div className="row" style={{ height: "1200px" }}>
          <div
            className="col-12"
            style={{ position: "relative", overflowX: "auto", height: "100%" }}
          >
            <Table>
              <thead>
                <tr className="text-center">
                  <th
                    onClick={() => handleSort("title")}
                    style={{ cursor: "pointer" }}
                  >
                    {t("panel.productTitle")} {getSortIndicator("title")}
                  </th>
                  <th
                    onClick={() => handleSort("total_orders_count")}
                    style={{ cursor: "pointer" }}
                  >
                    {t("panel.total_orders")} , {t("panel.totalQuantity")}{" "}
                    {getSortIndicator("total_orders_count")}
                  </th>
                  <th
                    onClick={() => handleSort("shipped_count")}
                    style={{ cursor: "pointer" }}
                  >
                    {t("panel.shippedOrders")}{" "}
                    {getSortIndicator("shipped_count")}
                  </th>
                  <th
                    onClick={() => handleSort("delivered_cash_delivery_count")}
                    style={{ cursor: "pointer" }}
                  >
                    {t("panel.soldOrders")}{" "}
                    {getSortIndicator("delivered_cash_delivery_count")}
                  </th>
                  <th
                    onClick={() => handleSort("pending_count")}
                    style={{ cursor: "pointer" }}
                  >
                    {t("panel.shippedorders")} (جاري الشحن + الغاء في الطريق +
                    مرتجع في الطريق) {getSortIndicator("pending_count")}
                  </th>
                  <th
                    onClick={() => handleSort("total_sys_commission")}
                    style={{ cursor: "pointer" }}
                  >
                    {t("panel.sysCommission")}{" "}
                    {getSortIndicator("total_sys_commission")}
                  </th>
                  <th
                    onClick={() => handleSort("total_seller_commission")}
                    style={{ cursor: "pointer" }}
                  >
                    {t("panel.sellerCommission")}{" "}
                    {getSortIndicator("total_seller_commission")}
                  </th>
                  <th
                    onClick={() => handleSort("total_marketer_commission")}
                    style={{ cursor: "pointer" }}
                  >
                    {t("panel.marketer_commission")}{" "}
                    {getSortIndicator("total_marketer_commission")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {allData.length > 0 &&
                  allData.map((item) => {
                    const totalOrders = Number(item?.total_orders_count);
                    const totalQuantity = Number(item?.total_quantity);
                    const shippedOrders = Number(item?.shipped_count);
                    const shippedQuantity = Number(item?.shipped_quantity);
                    const deliveredOrders = Number(
                      item?.delivered_cash_delivery_count
                    );
                    const deliveredQuantity = Number(
                      item?.delivered_cash_delivery_quantity
                    );

                    return (
                      <tr className="text-center" key={item?.id}>
                        <td>
                          <strong>#{item?.id}</strong>
                          <br />
                          {item?.title}
                          <br />
                          {Number(item?.stock_quantity).toLocaleString()} قطعة
                        </td>
                        <td>
                          {totalOrders.toLocaleString()}{" "}
                          {t("panel.orders_count")}
                          <br />
                          {totalQuantity.toLocaleString()}{" "}
                          {t("panel.orders_quantity")}
                        </td>
                        <td>
                          ({((shippedOrders / totalOrders) * 100).toFixed(1)}%)
                          <br />({shippedOrders.toLocaleString()}){" "}
                          {t("panel.orders_count")}
                          <br />({shippedQuantity.toLocaleString()}){" "}
                          {t("panel.orders_quantity")}
                        </td>
                        <td>
                          {deliveredOrders.toLocaleString()}{" "}
                          {t("panel.orders_count")}
                          <br />({deliveredQuantity.toLocaleString()}){" "}
                          {t("panel.orders_quantity")}
                          <br />
                          {((deliveredOrders / totalOrders) * 100).toFixed(
                            1
                          )}% {t("panel.fromTotal")}
                          <br />
                          {((deliveredOrders / shippedOrders) * 100).toFixed(1)}
                          % {t("panel.fromShipped")}
                        </td>
                        <td>{Number(item?.pending_count).toLocaleString()}</td>
                        <td>
                          {Number(item?.total_sys_commission).toLocaleString()}
                        </td>
                        <td>
                          #{item?.seller?.id} <br /> {item?.seller?.first_name}
                          {item?.seller?.last_name}
                          <br />
                          {Number(
                            item?.total_seller_commission
                          ).toLocaleString()}
                        </td>
                        <td>
                          {Number(
                            item?.total_marketer_commission
                          ).toLocaleString()}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsOverview;
